<template>
  <g :id="hand.id">
    <path fill="#231F20" d="M71.9987,129.2752c1.096-0.0014,1.9855,0.8858,1.987,1.9818s-0.8858,1.9855-1.9818,1.987
			c-1.096,0.0014-1.9855-0.8858-1.987-1.9818c0-0.0002,0-0.0002,0-0.0003C70.0158,130.1661,70.903,129.2768,71.9987,129.2752z
			 M71.0845,131.2607c0.0008,0.5061,0.4116,0.9159,0.9178,0.9152c0.5062-0.0007,0.9159-0.4116,0.9152-0.9178
			c-0.0007-0.506-0.4112-0.9155-0.9171-0.9152c-0.5057,0.0001-0.9156,0.4102-0.9155,0.9159c0,0.0007,0,0.0015,0,0.0022
			L71.0845,131.2607z"/>
    <polygon fill="#FFFFFF" points="73.5398,127.0055 72.7877,129.2567 71.2111,129.2584 70.4523,127.0084 71.9905,122.2556 		"/>
    <path fill="#231F20" d="M72.583,128.9735l-1.1689,0.0015l-0.6633-1.9684l1.2404-3.8336l1.2499,3.8306l-0.6583,1.9697
			 M72.9914,129.5397l0.847-2.534l-1.8493-5.6671l-1.8353,5.6714l0.8531,2.5323L72.9914,129.5397L72.9914,129.5397z"/>
    <polygon fill="#231F20" points="72.9914,129.5402 72.9906,128.7172 71.0064,128.7195 71.0072,129.5425 		"/>
  </g>
</template>

<script>
export default {
  name: 'sdHandSmallSecond',
  props: ['data'],
  computed: {
    hand() {
      if (this.data.hand) return this.data.hand;
    },
    watch() {
      if (this.data.watch) return this.data.watch;
    },
  },

};
</script>
